<template>
  <section class="h_62">
    <m-img src="@/v2/mobile/assets/image/h_62_0.jpg"></m-img>
    <f-swiper-mobile
      class="swiper-container"
      :gap="24"
      :total="controlList.length"
      :activeIndex="activeIndex"
      @update:activeIndex="activeIndex = $event"
      v-ia
    >
      <div
        v-for="(item, index) in controlList"
        :key="index"
        class="swiper-item"
      >
        <div class="swiper-title">{{ item.title }}</div>
        <div class="swiper-subtitle">{{ item.subTitle }}</div>
        <div class="swiper-item-card">
          <img v-if="item.type === 'img'" class="img" :src="item.url" alt="" />
          <m-video
            v-else
            class="video"
            :ref="`video${index}`"
            :src="item.url"
            muted
            disablepictureinpicture
            x5-playsinline
            playsinline
            webkit-playsinline="true"
          />
        </div>
        <Replay
          v-if="item.type === 'video'"
          class="alive_replay"
          @click="replayVideo($refs[`video${index}`][0])"
        />
      </div>
    </f-swiper-mobile>
  </section>
</template>

<script>
import Replay from '@/components/replay.vue'
import { replayVideo } from '@/utils'

export default {
  name: 'Assistant',
  components: {
    Replay,
  },
  data() {
    return {
      activeIndex: 0,
      preload_: true,
      isActive: false,
      controlList: [
        {
          title: '开门危险，先知预警',
          subTitle: '副驾开门遇后方来车，屏幕即刻弹出警示小窗',
          type: 'img',
          url: require('@/v2/mobile/assets/image/h_62_1.jpg'),
        },
        {
          title: '自动除霜，视野无余',
          subTitle: '挡风玻璃有霜、雾时，自动为你清除',
          type: 'video',
          url: require('@/v2/mobile/assets/video/62/1.mp4'),
        },
        {
          title: '感应尾门，解放双手',
          subTitle: '视觉识别用户动作，后备箱自动优雅开启',
          type: 'video',
          url: require('@/v2/mobile/assets/video/62/2.mp4'),
        },
        {
          title: '穿透雨雾，智慧灯控',
          subTitle: '雨雾天气自动开启雾灯，极大提升穿透力',
          type: 'video',
          url: require('@/v2/mobile/assets/video/62/3.mp4'),
        },
        {
          title: '夜视增强，清晰如昼',
          subTitle: '智能增强夜间成像，精准掌控暗夜倒车视野',
          type: 'video',
          url: require('@/v2/mobile/assets/video/62/4.mp4'),
        },
        {
          title: '智控车窗，提前预判',
          subTitle: '智能识别车内外环境，为你自动执行',
          type: 'video',
          url: require('@/v2/mobile/assets/video/62/5.mp4'),
        },
      ],
    }
  },
  mounted() {
    this.handleScroll = () => {
      const section = this.$el
      const rect = section.getBoundingClientRect()
      // 判断元素是否进入视口
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        this.initAutoPlay()
        window.removeEventListener('scroll', this.handleScroll)
      }
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // 清理定时器
    if (this.timer) {
      clearTimeout(this.timer)
    }
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    activeIndex() {
      this.initAutoPlay()
    },
  },
  methods: {
    controlClick(url, index) {
      this.activeIndex = index
    },
    replayVideo,
    initAutoPlay() {
      this.controlList.forEach((item, i) => {
        if (i === this.activeIndex) {
          this.playHandler(item, i)
        } else {
          this.pauseHandler(item, i)
        }
      })
    },
    playHandler(item, index) {
      if (item.type === 'img') {
        // 第一个静态图翻页时间为5秒，其他静态图保持3秒
        const delay = index === 0 ? 5000 : 3000
        this.timer = setTimeout(() => {
          this.videoPlayHandler()
        }, delay)
      } else {
        const video = this.$refs[`video${index}`][0]
        video.currentTime = 0
        video.play()
        video.addEventListener('ended', this.videoPlayHandler)
      }
    },
    pauseHandler(item, index) {
      if (item.type === 'video') {
        const video = this.$refs[`video${index}`][0]
        if (video) {
          video.currentTime = 0
          video.pause()
          video.removeEventListener('ended', this.videoPlayHandler)
        }
      }
    },
    videoPlayHandler() {
      this.timer && clearTimeout(this.timer)
      if (this.activeIndex < this.controlList.length - 1) {
        this.activeIndex++
      } else {
        // 播放完最后一个，重置为0
        this.activeIndex = 0
      }
      this.initAutoPlay()
    },
  },
}
</script>

<style lang="less" scoped>
.h_62 {
  position: relative;
  z-index: 38;
  .swiper-container {
    position: absolute;
    overflow: hidden;
    top: 40%;
  }
  .swiper-item {
    width: 100%;
    color: #fff;
    .swiper-item-card {
      width: calc(100% - 24px);
      aspect-ratio: 1.7;
      overflow: hidden;
      border-radius: 12px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .swiper-title {
      font-size: 5vw;
      font-weight: bold;
      color: #fff;
    }

    .swiper-subtitle {
      font-size: 3.6vw;
      color: #ffffff80;
      margin: 10px 0 24px;
    }
    .alive_replay {
      margin-left: 3px;
      margin-top: 0.3rem;
      color: #3b82fc;
    }
  }
}
</style>
